import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ayKey, gunKey, ayinGunleri, AY_ADLARI, paraCevir } from './takvim';

export const exportPuantajExcel = (yil, ay, ustalar, santiyeler, calisma, avanslar) => {
  const gunler = ayinGunleri(yil, ay);
  const ak = ayKey(yil, ay);
  
  // --- 1. PUANTAJ BÖLÜMÜ (ÜST TABLO) ---
  const puantajData = [];
  
  // Başlık Satırı (Günler | Usta1 | Usta2 ...)
  const ustaIsimleri = ustalar.map(u => u.ad);
  puantajData.push([`${AY_ADLARI[ay].toUpperCase()} PUANTAJ`]); // Ana Başlık
  puantajData.push(["GÜNLER", ...ustaIsimleri]); // Sütun Başlıkları

  // Günlük Satırlar
  gunler.forEach(t => {
    const gk = gunKey(t);
    const satir = [t.toLocaleDateString('tr-TR')]; // İlk sütun tarih
    
    ustalar.forEach(u => {
      const sId = calisma[gk]?.[u.id];
      const s = santiyeler.find(x => x.id === sId);
      satir.push(s ? s.ad : ""); // Ustanın o günkü şantiyesi
    });
    puantajData.push(satir);
  });

  // Puantaj Alt Toplamları (Yövmiye Adet, Yövmiye TL, Borç)
  const yovmiyeAdet = ["YÖVMİYE ADET"];
  const yovmiyeTL = ["YÖVMİYE"];
  const hakedisBorc = ["BORÇ"];

  ustalar.forEach(u => {
    let count = 0;
    gunler.forEach(t => { if(calisma[gunKey(t)]?.[u.id]) count++; });
    yovmiyeAdet.push(count);
    yovmiyeTL.push(Number(u.yovmiye) || 0);
    hakedisBorc.push(count * (Number(u.yovmiye) || 0));
  });

  puantajData.push([]); // Boşluk
  puantajData.push(yovmiyeAdet);
  puantajData.push(yovmiyeTL);
  puantajData.push(hakedisBorc);
  puantajData.push([]); // Ayırıcı boşluk
  puantajData.push([]); // Ayırıcı boşluk

  // --- 2. AVANS BÖLÜMÜ (ALT TABLO) ---
  puantajData.push([`${AY_ADLARI[ay].toUpperCase()} AVANS`]);
  puantajData.push(["GÜNLER", ...ustaIsimleri]);

  gunler.forEach(t => {
    const gk = gunKey(t);
    const satir = [t.toLocaleDateString('tr-TR')];
    ustalar.forEach(u => {
      const av = avanslar[u.id]?.[gk] || "";
      satir.push(av);
    });
    puantajData.push(satir);
  });

  // Avans Alt Toplamı
  const toplamAvansSatiri = ["TOPLAM AVANS"];
  ustalar.forEach(u => {
    const uAvanslar = avanslar[u.id] || {};
    const toplam = Object.values(uAvanslar).reduce((a, b) => a + Number(b || 0), 0);
    toplamAvansSatiri.push(toplam);
  });
  puantajData.push(toplamAvansSatiri);

  // --- EXCEL DOSYASINI OLUŞTUR ---
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(puantajData);

  // Hücre genişliklerini ayarla
  const wscols = [{ wch: 12 }, ...ustaIsimleri.map(() => ({ wch: 15 }))];
  ws['!cols'] = wscols;

  XLSX.utils.book_append_sheet(wb, ws, "Puantaj");
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  
  saveAs(data, `${AY_ADLARI[ay]}_${yil}_Puantaj_Cetveli.xlsx`);
};